import React, { Component } from 'react';
import './css/App.css';
import './css/custom.css';
import ErrorMessage from './Util/ErrorMessage';
import AuthButton from './Auth/AuthButton';
import withAuthProvider, { AuthComponentProps } from './Auth/AuthProvider';

class App extends Component<AuthComponentProps> {

  render() {
    let error = null;
    if (this.props.error) {
      error = <ErrorMessage
        title={this.props.error.title}
        message={this.props.error.message}
        debug={this.props.error.debug}
      />;
    }

    return (
      <div>
        {error}
        <section className="content-area white">
          <div className="card-md">
          <h2 className="card-title">Instructions</h2>
            <div>
              <div className="highlight">Complete the following steps to copy your Mosaic class schedule to your Outlook Calendar.
                Please note: Any changes to your schedule (e.g. drop & add, or room changes) will be reflected automatically in Mosaic;
                however, you will need to follow these steps again to have the changes copied over to your Outlook Calendar.
                It may take one day for the revised Mosaic class schedule data to be updated before you can copy it to your Outlook Calendar.
              </div>
              <h2 className="card-title">Sign In</h2>
            </div>
            <div>
              <AuthButton
                isAuthenticated={this.props.isAuthenticated}
                user={this.props.user}
                authButtonMethod={this.props.isAuthenticated ? this.props.logout : this.props.login}
              />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withAuthProvider(App);
